import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isEmailNotVerifiedError = (error) =>
  error?.response?.data?.detail === 'EMAIL_NOT_VERIFIED';

export const resendVerificationEmail = async () => {
  await axios.post(`${API}/auth/resend-verification`, {}, { withCredentials: true });
};

/* Shown when a core action (post/message/profile edit) is blocked by the
   backend's EMAIL_NOT_VERIFIED guard. Gives the user a one-click resend
   right from the toast so they don't have to hunt for the banner. */
export const showEmailVerificationRequiredToast = (t) => {
  toast.error(t('emailVerify.actionBlocked'), {
    action: {
      label: t('emailVerify.resendButton'),
      onClick: async () => {
        try {
          await resendVerificationEmail();
          toast.success(t('emailVerify.resendSuccess'));
        } catch (e) {
          toast.error(e.response?.data?.detail || t('emailVerify.resendFailed'));
        }
      },
    },
    duration: 8000,
  });
};
